const AuthButton = ({ 
  children, 
  onClick, 
  disabled = false, 
  loading = false, 
  loadingText = "Loading...",
  className = "",
  type = "button",
  ...props 
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`group relative w-full overflow-hidden rounded-xl bg-gradient-to-r from-emerald-500 to-emerald-600 px-4 py-3 text-sm font-semibold text-white shadow-lg transition-all duration-300 hover:from-emerald-600 hover:to-emerald-700 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-emerald-400/50 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      {...props}
    >
      <span className="flex relative z-10 gap-2 justify-center items-center">
        {loading ? (
          <>
            <div className="w-4 h-4 rounded-full border-2 border-white animate-spin border-t-transparent" />
            {loadingText}
          </>
        ) : (
          children
        )}
      </span>
      <div className="absolute inset-0 bg-gradient-to-r transition-transform duration-700 -translate-x-full from-white/0 via-white/20 to-white/0 group-hover:translate-x-full"></div>
    </button>
  );
};

export default AuthButton;
